import { render, staticRenderFns } from "./errorpage.vue?vue&type=template&id=e48c4474&scoped=true"
import script from "./errorpage.vue?vue&type=script&lang=js"
export * from "./errorpage.vue?vue&type=script&lang=js"
import style0 from "./errorpage.vue?vue&type=style&index=0&id=e48c4474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48c4474",
  null
  
)

export default component.exports